import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import "./SearchAutoComplete.scss";

export default function SearchAutoComplete({
  optionsData = [],
  onChange,
  value,
  name,
  isError = false,
  errorMsg = "",
  id,
  disabled,
  isUserDetails,
  typeOnchange,
  isKeyValuePair,
  isLoading = false,
  isRegNum = false,
  placeholderText = "",
  noOptionsTextMsg = "No user",
  autoCompClear = null,
  handleFocus,
}) {
  const [inputValue, setInputValue] = useState("");
  useEffect(() => {
    if (value) {
      const label = getLabel(value);
      setInputValue(label || "");
    } else {
      setInputValue("");
    }
  }, [value]);
  const normalizeText = (str) => str?.toLowerCase().replace(/\s+/g, " ").trim();
  // Label handler
  const getLabel = (option) => {
    if (!option) return "";
    if (isUserDetails) {
      return `${option.firstName || ""} ${option.lastName || ""}`.trim();
    }
    if (isKeyValuePair) {
      return option?.value || "";
    }
    if (isRegNum) {
      return option?.regNumber || "";
    }
    return "";
  };

  //filter options based on input
  const filteredOptions = (optionsData || [])
    .map((opt) => ({
      ...opt,
      value: normalizeText(getLabel(opt)),
    }))
    .filter((option) =>
      normalizeText(option.value).includes(normalizeText(inputValue))
    );

  const hasTypedInput = inputValue.trim().length > 0;

  return (
    <div className="overideSearchAuto">
      <Autocomplete
        popupIcon={<SearchIcon />}
        disablePortal
        disabled={disabled}
        name={name || "defaultName"}
        id={id}
        value={value || null}
        loading={isLoading}
        options={hasTypedInput ? filteredOptions : []}
        size="small"
        noOptionsText={
          hasTypedInput ? noOptionsTextMsg : "Start typing to search"
        }
        clearOnEscape={true}
        ref={autoCompClear}
        getOptionLabel={(option) => getLabel(option)}
        onChange={(event, newValue) => {
          onChange(event, newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === "clear") {
            setInputValue("");
          } else {
            setInputValue(newInputValue);
          }

          if (event) {
            typeOnchange(event, newInputValue);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            error={isError}
            placeholder={placeholderText}
            helperText={errorMsg}
            className="formControlRoot"
            style={{ borderRadius: "15px" }}
            InputProps={{
              className: "inputRoot",
              ...params.InputProps,
            }}
            onFocus={handleFocus}
          />
        )}
      />
    </div>
  );
}
